export default __webpack_public_path__ + "static/media/africexpay-preview.2771848c.png";